import { render, staticRenderFns } from "./DetailDebit.vue?vue&type=template&id=e6baa730"
import script from "./DetailDebit.vue?vue&type=script&lang=js"
export * from "./DetailDebit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports